export const drawerBackgroundColor = '#F1F2F7';
export const drawerIconColor = '#606060';
export const drawerActiveIconColor = '#2E90FA';
export const drawerItemActiveItem = '#2E90FA';
export const drawerItemActiveBackground = '#5595CD26';
export const drawerItemTextColor = '#3A3A3A';
export const sicknessDashboardCard = '#1570EF';
export const Brand600 = '#1570EF';
export const warning100 = '#FEF0C7';
export const warning500 = '#F79009';
export const warning600 = '#DC6802';
export const error600 = '#D92D20';
